import type { TFunction } from 'i18next';

import { z } from 'zod';

import { isValidDateInput } from './date-input.ts';

export const createExperienceSchema = (t: TFunction) =>
  z.object({
    title: z.string().min(1, t('Forms.PastExperience.errors.title')),
    company: z.string().min(1, t('Forms.PastExperience.errors.employer')),
    // City is optional (soft rule): an empty value is accepted.
    location: z.string().nullable().optional(),
    // Dates are optional and the month is never blocking:
    // the candidate can leave them empty or give the year alone.
    startDate: z
      .string()
      .optional()
      .refine(value => isValidDateInput(value ?? ''), t('Forms.PastExperience.errors.dateInvalid')),
    endDate: z
      .string()
      .optional()
      .nullable()
      .refine(value => isValidDateInput(value ?? ''), t('Forms.PastExperience.errors.dateInvalid')),
    missions: z.string().min(1, t('Forms.PastExperience.errors.missions')).optional(),
  });

export type ExperienceFormValues = z.infer<ReturnType<typeof createExperienceSchema>>;
